import React from 'react';

import { TableCell } from '@mui/material';
import { useTranslation } from 'react-i18next';

import TableTotalFooter from '../../../../components/TableTotalFooter';
import { IStaffTravel } from '../../../../types/staff-travel.type';
import { ArrayUtils } from '../../../../utils/array.utils';

interface IProps {
  travel: IStaffTravel[];
}

const StaffTravelListFooter = React.memo(({ travel }: IProps) => {
  const { t } = useTranslation();

  const renderTotalRow = React.useMemo(
    () => (
      <>
        <TableCell sx={{ fontWeight: 'bold' }}>{t(`general.total`)}</TableCell>
        <TableCell />
        <TableCell />
        <TableCell />
        <TableCell>{ArrayUtils.calculateTotal(travel, 'total')}</TableCell>
      </>
    ),
    [travel, t],
  );

  return <TableTotalFooter textAlign="center">{renderTotalRow}</TableTotalFooter>;
});

export default StaffTravelListFooter;
